import DataTableStatic from 'components/organisms/data-table-static'
import customerOrderShipmentItemTableColumns from 'domains/customer-order/molecules/shipment-item-table-columns'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'

const propTypes = {
  data            : PropTypes.array,
  hiddenColumns   : PropTypes.array,
  defaultPageSize : PropTypes.number,
  showPagination  : PropTypes.bool,
  showModalImage  : PropTypes.func
}

const defaultValues = {
  data           : [],
  hiddenColumns  : [ 'action' ],
  showPagination : true
}

/**
 * @param {Array<Object>} data - array of shipment items objects
 */
const CustomerOrderShipmentItemListTable = ({
  data,
  hiddenColumns,
  showPagination,
  defaultPageSize,
  showModalImage
}) => {

  /**
   * It's important that we're using React.useMemo
   * here to ensure that our data isn't recreated on every render.
   * see https://react-table.tanstack.com/docs/quick-start
   *  */
  const columns = useMemo(() => customerOrderShipmentItemTableColumns({ showModalImage }), [ showModalImage ])

  return (
    <DataTableStatic
      data={ data }
      columns={ columns }
      hiddenColumns={ hiddenColumns }
      showPagination={ showPagination }
      defaultPageSize={ defaultPageSize }
    />
  )
}

CustomerOrderShipmentItemListTable.propTypes    = propTypes
CustomerOrderShipmentItemListTable.defaultProps = defaultValues

export default CustomerOrderShipmentItemListTable